import React, { useMemo } from 'react';

import { useAppSelector } from '../../../../hooks/react-redux';
import { getClientPageUsageAnalytics, getFetchingAnalytics } from '../../../admin/analytics/store/selectors';
import { AdminAnalyticsChart, ClientPageUsage } from '../../../admin/analytics/store/types';
import { Document } from '../../../shared/icons';
import { ChartLoading } from '../ChartLoading';
import styles from '../Modules.module.scss';
import { PieChartWrapper } from '../PieChartWrapper';

const { mandatory, amber, frenchLight, lightestGrey } = styles;

interface PageUsageChartProps {
    dimensions?: {
        height: number;
        width: number;
    }
    analyticsSpinner: boolean;
}

const getDataColour = (key: string) => {
    if (key === ClientPageUsage.AVAILABLE_PAGES) return frenchLight;
    if (key === ClientPageUsage.AVAILABLE_FREE_PAGES) return mandatory;
    return amber;
};

export const PageUsageChart: React.FC<PageUsageChartProps> = ({ dimensions, analyticsSpinner }) => {
    const data = useAppSelector(getClientPageUsageAnalytics);
    const fetchingAnalytics = useAppSelector(getFetchingAnalytics);
    const showSpinner = useMemo(() => fetchingAnalytics.includes(AdminAnalyticsChart.PAGE_USAGE) || analyticsSpinner, [fetchingAnalytics, analyticsSpinner]);

    const filteredData = useMemo(() => data.filter(({ value }) => value).map(data => ({ ...data, color: getDataColour(data.key) })), [data]);

    if (showSpinner) {
        return <ChartLoading dimensions={dimensions} />;
    }

    return (
        <PieChartWrapper
            data={filteredData}
            dimensions={dimensions}
            icon={Document}
            testId='homepage-page-usage'
            label='Page Usage'
            iconFill={lightestGrey}
        />
    );
};
